// Pure formatting helpers for the Raw CDR Report page. Extracted from index.js
// so the regression coverage for #9448 (epoch-0 -> blank) can unit-test
// fmtDateTime directly without importing the React component module.

export const pad = (n) => String(n).padStart(2, "0");

export function fmtDateTime(epochSeconds) {
  if (epochSeconds === null || epochSeconds === undefined || epochSeconds === "") return "";
  const n = Number(epochSeconds);
  // Epoch 0 (FreeSWITCH convention for unanswered legs on answer_epoch /
  // end_epoch) must render as blank, not as "1970-01-01 …" — this is the
  // #9448 integrated-testing fail reported by Umesh on 2026-06-02.
  if (!Number.isFinite(n) || n <= 0) return "";
  const d = new Date(n * 1000);
  if (Number.isNaN(d.getTime())) return "";
  // yyyy-MM-dd HH:mm:ss (ISO-like, sortable; per Naveen's choice on the format).
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(
    d.getHours()
  )}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}

// Formats a Date object to the datetime-local input shape "yyyy-MM-ddTHH:mm"
// used by quickSelect preset range buttons. Distinct from fmtDateTime which
// consumes epoch seconds and emits "yyyy-MM-dd HH:mm:ss".
export const fmtLocalInput = (d) =>
  `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(
    d.getMinutes()
  )}`;

export function mmss(sec) {
  if (sec === null || sec === undefined || sec === "") return "";
  const s = Number(sec);
  return `${pad(Math.floor(s / 60))}:${pad(s % 60)}`;
}
